import { useState } from 'react'
import Api from 'services/api'

const useZendeskUpload = () => {
  const [loading, setLoading] = useState(false)
  const uploadScreenshot = async (
    file: File
  ) => {
    try {
      setLoading(true)
      const formData = new FormData()
      formData.append('file', file)
      const response = await Api.Zendesk.upload(formData)
      return response.token
    } finally {
      setLoading(false)
    }
  }

  return { uploadScreenshot, loading }
}

export default useZendeskUpload
